export { default } from './StatisticsBarChart'
